module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-inbound-fill-22d95b3c.svg";